module.exports = __webpack_public_path__ + "img/headerXs.14de8780.png";